module.exports = __webpack_public_path__ + "744f682098d94f4402a4d97879f258cc.png";